export default {
  plural: 'Twins',
  singular: 'Twin',
  create: 'Создать twin',
  code: 'Код',
  name: 'Название',
  integrationCodes: {
    title: 'Коды интеграций',
    hint: 'Как эту опцию называет внешний магазин — артикул, идентификатор терма атрибута и подобное. Виджет адресуется по ним, а не по нашим кодам.',
    addRow: 'Добавить код'
  },
  status: {
    draft: 'Черновик',
    published: 'Опубликован',
    deactivated: 'Деактивирован'
  },
  searchPlaceholder: 'Поиск twin по названию',
  workspace: {
    publish: 'Опубликовать',
    comingSoon: 'Скоро',
    tabs: {
      variants: 'Варианты',
      parts: 'Слоты и детали',
      materials: 'Зоны и материалы',
      rules: 'Правила',
      preview: 'Превью'
    }
  },
  simple: {
    steps: {
      model: 'Модель',
      parts: 'Детали',
      materials: 'Материалы'
    },
    notConfigured: 'не выбрано',
    title: 'Простой режим'
  },
  variants: {
    plural: 'Варианты',
    addVariant: 'Добавить вариант',
    createTitle: 'Базовая модель',
    editTitle: 'Базовая модель',
    deleteTitle: 'Удалить вариант',
    deleteWarning: 'Вы уверены, что хотите удалить этот вариант?',
    defaultLabel: 'По умолчанию',
    setDefault: 'Вариант по умолчанию',
    product: 'CRM-продукт',
    baseModel: 'Базовая модель',
    noVariants: 'Вариантов пока нет',
    changeBaseModel: 'Заменить модель',
    noBaseModel: 'Базовая модель не выбрана'
  },
  parts: {
    createTitle: 'Добавить деталь',
    addPart: 'Добавить деталь',
    save: 'Сохранить',
    remove: 'Убрать',
    glbAsset: 'GLB-ассет',
    noVariants: 'Сначала создайте вариант',
    noBaseModel: 'У этого варианта ещё нет базовой модели',
    noSockets: 'У базовой модели нет сокетов',
    noParts: 'Детали не назначены',
    noConnector: 'У детали нет коннектора, нельзя назначить:',
    compatible: 'Совместимо',
    existingGlbAsset: 'Существующий ассет',
    uploadNewGlbAsset: 'Загрузить новый GLB',
    newGlbAssetName: 'Новый GLB-ассет'
  },
  library: {
    searchPlaceholder: 'Поиск по библиотеке',
    empty: 'В библиотеке пока пусто',
    noGlb: 'GLB не прикреплён',
    noProduct: 'Без продукта'
  },
  socketPanel: {
    title: 'Правила сокета',
    modeLabel: 'Режим сокета',
    acceptByRule: 'Автоподбор по правилам',
    curatedOnly: 'Только выбранные детали',
    candidates: 'Итоговые кандидаты',
    noCandidates: 'Виджет пока не резолвит кандидатов для этого сокета',
    candidatesHint:
      'То, что реально предложит виджет — из живого viewer-пейлоада',
    patternAffects: 'Этот паттерн затронет',
    prefixOverMatchWarning:
      'socketPattern всегда матчится как префикс — правило также накроет',
    socketsTitle: 'Сокеты модели',
    searchPlaceholder: 'Поиск сокета...',
    selectSocket: 'Выберите сокет слева, чтобы настроить его детали',
    assignedTitle: 'Назначенные детали',
    assignedHint: 'Сохраняются кнопкой «Сохранить» ниже',
    inheritedTitle: 'Приходят из правил',
    inheritedHint:
      'Резолвятся виджетом по правилам — добавьте, чтобы редактировать локально',
    modeHintAcceptByRule:
      'Детали, подходящие по правилам, добавляются поверх назначенных.',
    modeHintCuratedOnly:
      'В сокете останутся только явно назначенные детали, правила ничего не добавят.',
    modeSavesImmediately: 'сохраняется сразу',
    nestedOn: 'на',
    emptySocket: 'Сокет пуст — назначьте хотя бы одну деталь.',
    configuredCount: 'настроено'
  },
  sections: {
    base: 'Базовая модель',
    slots: 'Слоты и детали',
    materials: 'Зоны и материалы',
    rules: 'Правила',
    preview: 'Превью и публикация',
    copyId: 'Копировать id конфигуратора',
    copied: 'Скопировано'
  },
  wizard: {
    title: 'Новый твин',
    stepBase: 'Основа',
    next: 'Далее',
    back: 'Назад',
    finish: 'Завершить',
    createAndContinue: 'Создать и продолжить',
    fromLibrary: 'Из библиотеки',
    uploadNew: 'Загрузить новый GLB',
    basisRequired: 'Выберите или загрузите базовую модель',
    productRequired: 'Нужен продукт CRM',
    companyRequired: 'Нужна компания',
    nameRequired: 'Нужно название',
    codeRequired: 'Нужен код'
  },
  crm: {
    sectionTitle: '3D',
    rolePart: 'Деталь',
    roleVariant: 'Основа',
    usedInConfigurators: 'Используется в конфигураторах',
    notUsed: 'Пока не используется в конфигураторах',
    usageMayBeIncomplete:
      'Счётчики использования могут быть неполными — записей больше, чем удалось загрузить.',
    listMayBeIncomplete:
      'Часть записей может не отображаться — их больше, чем удалось загрузить.',
    empty: 'У продукта пока нет 3D-сущностей',
    materialsEmpty: 'У материала пока нет twin-материалов',
    addModel: 'Добавить 3D-модель',
    addTwinMaterial: 'Добавить twin-материал',
    roleQuestion: 'Что это за модель?',
    companyLabel: 'Компания твина',
    configuratorLabel: 'Конфигуратор',
    createNewConfigurator: 'Нужен новый конфигуратор? Открыть визард'
  }
};
